import { createContext, useContext } from 'react';
import { Dashboard } from './dashboard';

export const DashboardContext = createContext<Dashboard | null>(null);

export function useDashboardContext() {
  const context = useContext(DashboardContext);

  if (!context) throw new Error('There is no Dashboard context');

  return context;
}
